import { createContext } from 'react'

const fetchContext = createContext()

export default fetchContext